import React, { useEffect, useRef, useState } from "react"
import { COPY_STRINGS } from "../../../../constants/translatedCopy"
import {  isSafariMobile } from '../../functions/browserChecks'
import { amiraGestures } from '../../../Coach/GesturedSpeech'
import IOSMicrophonePermissionPrompt from "./IOSMicrophonePermissionPrompt"
import OtherBrowserMicrophonePermissionPrompt from "./OtherBrowserMicrophonePermissionPrompt"
import './PromptToAllowPermission.scss'

export default React.memo(function PromptToAllowPermission(props){

    const { speechProps, setPermissionState } = props

    const [ readyToPrompt, setReadyToPrompt ] = useState(false)

    const allowMicVerbalPromptTimer = useRef()
    const allowMicVerbalPromptCount = useRef(0)

    useEffect(()=>{
        promptAllow()
        startAllowMicVerbalPromptTimer()

        return () => {
            cancelAllowMicVerbalPromptTimer()
        }
    }, [])

    useEffect(()=>{
        if(readyToPrompt){
            // stop reminder to press fake allow prompt when pressed.
            cancelAllowMicVerbalPromptTimer()
        }
    }, [readyToPrompt])

    useEffect(()=>{

        if(allowMicVerbalPromptCount.current < 4){
            startAllowMicVerbalPromptTimer()
        }

    }, [allowMicVerbalPromptCount.current])

    const startAllowMicVerbalPromptTimer = () => {
        cancelAllowMicVerbalPromptTimer()
        allowMicVerbalPromptTimer.current = setTimeout(  () => {
            promptAllow()
        }, 20000)
    }

    const cancelAllowMicVerbalPromptTimer = () => {
        clearTimeout(allowMicVerbalPromptTimer.current)
    }

    const promptAllow = async () => {
        if(allowMicVerbalPromptCount.current === 0){
            speechProps.abortDance();
            speechProps.playDance({
                gesture: amiraGestures.Playful_to_Facepalm,
            })
            await speechProps.speakWithPromise({
                textToSpeak: COPY_STRINGS.student_checks.intro_microphone,
            })
            await speechProps.speakWithPromise({
                textToSpeak: COPY_STRINGS.student_checks.student_hardware_prompt_intro,
            })
            setReadyToPrompt(true)
            speechProps.speak({
                textToSpeak: COPY_STRINGS.student_checks.student_hardware_prompt_initial,
            })
        } else if(allowMicVerbalPromptCount.current === 1){
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.student_hardware_prompt})
        } else if(allowMicVerbalPromptCount.current === 2){
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.student_hardware_prompt_two})
        } else if(allowMicVerbalPromptCount.current > 2) {
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.handle_get_teacher})
        }
        allowMicVerbalPromptCount.current += 1
    }

    if(isSafariMobile()){
        return <IOSMicrophonePermissionPrompt
                readyToPrompt={readyToPrompt}
                raiseYourHand={allowMicVerbalPromptCount.current > 2}
                speechProps={speechProps}
                setPermissionState={setPermissionState} />
    }

    return <div className="microphone-prompt-to-allow">
        <OtherBrowserMicrophonePermissionPrompt
            readyToPrompt={readyToPrompt}
            raiseYourHand={allowMicVerbalPromptCount.current > 2}
            speechProps={speechProps}
            setPermissionState={setPermissionState}
            allowMicVerbalPromptCount={allowMicVerbalPromptCount} />
    </div>
})